/* @flow */

import React from 'react';
import CheckmarkCircleIcon from 'dibs-icons/exports/CheckmarkCircle';
import classnames from 'classnames';
import stepInspirationStyles from '../styles/FormStepInspiration.scss';

type ComponentProps = {|
    checked: boolean,
    name?: string,
    checkmarkNeeded?: boolean,
    imageInput: string | Element,
    selectedStyle: string,
    originalStyle: string,
    onChange: (selection: string) => void,
|};

function _onCheck(state: string, onChange: string => void) {
    return function() {
        onChange(state);
    };
}

export const PictureSelection = ({
    name,
    imageInput,
    checkmarkNeeded,
    checked,
    selectedStyle,
    originalStyle,
    onChange,
}: ComponentProps) => {
    const checkmarkClass = checked ? stepInspirationStyles.show : stepInspirationStyles.hide;
    const newValue = !name ? imageInput : name;
    const styling = classnames(stepInspirationStyles.icon, {
        [selectedStyle]: checked,
        [originalStyle]: !checked,
    });
    let body = null;
    if (typeof imageInput === 'string') {
        const image = { backgroundImage: `url("${imageInput}")` };
        body = <div className={styling} style={image} onClick={_onCheck(newValue, onChange)} />;
    } else {
        body = (
            <div className={styling} onClick={_onCheck(newValue, onChange)}>
                {imageInput}
            </div>
        );
    }

    return (
        <div className={stepInspirationStyles.pictureDiv}>
            {checkmarkNeeded ? <CheckmarkCircleIcon className={checkmarkClass} /> : null}
            {body}
        </div>
    );
};
